import { CategoriesScores, FunctionalLocationNode, WorkOrderWithScore } from './functional-location-hierarchy-scores-propagation.utils';

export class CategoryScoresCalculator {
  static calculateNodeCategoryScores(node: FunctionalLocationNode): void {
    const categoryScores = this.calculateWorkOrdersCategoryScores(node);

    node.Children.forEach(child => {
      this.sumCategoryScores(categoryScores, child.CategoryScores);
    });

    node.CategoryScores = categoryScores;
  }

  private static calculateWorkOrdersCategoryScores(node: FunctionalLocationNode): CategoriesScores {
    const totalScores: CategoriesScores = {
      PMScore: 0.0,
      LatenessScore: 0.0,
      PriorityScore: 0.0,
      ReadyToExecuteScore: 0.0,
      WorkTypeScore: 0.0,
      StatutoryFlagScore: 0.0
    };

    this.accumulateCategoryScores(node.ReleasedWorkOrders, totalScores);
    this.accumulateCategoryScores(node.NotReleasedWorkOrders, totalScores);

    return totalScores;
  }

  private static accumulateCategoryScores(
    workOrders: WorkOrderWithScore[],
    accumulatedScores: CategoriesScores
  ): void {
    workOrders.forEach(workOrder => {
      accumulatedScores.PMScore += this.setPositive(workOrder.CategoryScores.PMScore);
      accumulatedScores.ReadyToExecuteScore += this.setPositive(workOrder.CategoryScores.ReadyToExecuteScore);
      accumulatedScores.LatenessScore += this.setPositive(workOrder.CategoryScores.LatenessScore);
      accumulatedScores.PriorityScore += this.setPositive(workOrder.CategoryScores.PriorityScore);
      accumulatedScores.WorkTypeScore += this.setPositive(workOrder.CategoryScores.WorkTypeScore);
      accumulatedScores.StatutoryFlagScore += this.setPositive(workOrder.CategoryScores.StatutoryFlagScore);
    });
  }

  private static setPositive(ab: number): number {
    return Math.max(0, ab);
  }

  private static sumCategoryScores(target: CategoriesScores, source: CategoriesScores): void {
    target.PMScore += source.PMScore;
    target.ReadyToExecuteScore += source.ReadyToExecuteScore;
    target.LatenessScore += source.LatenessScore;
    target.PriorityScore += source.PriorityScore;
    target.WorkTypeScore += source.WorkTypeScore;
    target.StatutoryFlagScore += source.StatutoryFlagScore;
  }
}
